// extracted by mini-css-extract-plugin
export default {"styles":"PainItem_styles__w72Z2"};